module.exports = __webpack_public_path__ + "static/img/deportes_03.37b755c6.jpeg";